import { render, staticRenderFns } from "./codeBox.vue?vue&type=template&id=5dff6dfc&scoped=true&"
import script from "./codeBox.vue?vue&type=script&lang=js&"
export * from "./codeBox.vue?vue&type=script&lang=js&"
import style0 from "./codeBox.vue?vue&type=style&index=0&id=5dff6dfc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff6dfc",
  null
  
)

export default component.exports